export default {
  title: {
    en: 'Insights',
    sk: 'Blog',
  },
  all: {
    en: 'All',
    sk: 'Všetko',
  },
  articles: {
    en: 'Articles',
    sk: 'Články',
  },
  podcasts: {
    en: 'Podcasts',
    sk: 'Podcasty',
  },
  showcases: {
    en: 'Showcases',
    sk: 'Prípadovky',
  },
  videos: {
    en: 'Videos',
    sk: 'Videá',
  },
  events: {
    en: 'Events',
    sk: 'Podujatia',
  },
};



// WEBPACK FOOTER //
// ./src/scripts/modules/Insights/Categories/messages.js